<template>
  <div class="addProject">
    <el-form class="projectForm" :rules="projectFormRules" ref="projectForm" :model="projectForm" label-width="100px">
      <div class="row">
        <div class="base-info">
          <p>基本信息</p>
        </div>
        <div class="row-item">
          <el-form-item label="客户名称" prop="customerId">
            <el-select filterable v-model="projectForm.customerId" placeholder="请选择客户">
              <el-option v-for="item in customerList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物流加收费" prop="logisticsInterceptChargeFlag">
            <span slot="label">
              <span>物流加收费</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <div v-html="`当物流拦截不收费时，导入拦<br />截费用将不纳入月账单计算`" slot="content" style="line-height: 18px;"></div>
                <img class="help-hign" src="~assets/images/help/help-hign.png">
              </el-tooltip>
            </span>
            <el-select v-model="projectForm.logisticsInterceptChargeFlag" placeholder="请选择">
              <el-option v-for="item in logisticsPlusChargesList" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目名称" prop="projectName">
            <el-input v-model="projectForm.projectName" placeholder="请输入项目名称"></el-input>
          </el-form-item>
          <el-form-item label="合同面积" prop="contractArea">
            <span slot="label">
              <span>合同面积</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <div v-html="`保底面积，即当实占面积<br />低于合同面积时，以合同<br />面积计算场租`" slot="content" style="line-height: 18px;">
                </div>
                <img class="help-hign" src="~assets/images/help/help-hign.png">
              </el-tooltip>
            </span>
            <el-input @input="contractAreaInput" v-model="projectForm.contractArea" placeholder="请输入合同面积"></el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="head">
            <el-select v-model="projectForm.head" placeholder="请选择负责人">
              <el-option v-for="item in headList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分摊面积" prop="shareArea">
            <el-input @input="shareAreaInput" v-model="projectForm.shareArea" placeholder="请输入分摊面积"></el-input>
          </el-form-item>
          <el-form-item label="合同时间" prop="date">
            <el-date-picker v-model="projectForm.date" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="截单时间" prop="finalOrderTime" class="cut-time">
            <el-time-picker v-model="projectForm.finalOrderTime" format="HH:mm:ss" value-format="HH:mm:ss"
              placeholder="请选择截单时间">
            </el-time-picker>
          </el-form-item>
          <el-form-item label="数据来源" prop="dataSource">
            <el-select v-model="projectForm.dataSource" placeholder="请选择数据来源">
              <el-option v-for="item in dataSourceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="税率" prop="taxRate">
            <el-input @input="taxRateInput" v-model="projectForm.taxRate" placeholder="示例：税率6%，填写0.06"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="projectForm.remark" type="textarea" class="white" placeholder="请输入" maxlength="100"
              show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="物流税率" prop="logisticTaxRate" class="logistic-tax-rate">
            <el-input @input="logisticTaxRateInput" v-model="projectForm.logisticTaxRate"
              placeholder="示例：税率6%，填写0.06"></el-input>
          </el-form-item>
          <el-form-item label="项目简介" prop="projectsDesc">
            <el-input v-model="projectForm.projectsDesc" type="textarea" class="white" placeholder="请输入"
              maxlength="500" show-word-limit></el-input>
          </el-form-item>
        </div>

        <div class="switch-title">
          <p class="sub-title">综合保底</p>
          <el-switch class="custom-switch" active-color="#2E68EA"
            v-model="projectForm.hasOpenComprehensiveMinimumGuarantee"
            :active-text="projectForm.hasOpenComprehensiveMinimumGuarantee?'开启保底':'关闭保底'">
          </el-switch>
        </div>
        <div class="row-item" v-show="projectForm.hasOpenComprehensiveMinimumGuarantee">
          <el-form-item label="综合保底" prop="comprehensiveMinimumGuaranteeAmount" style="margin-bottom: 8px;" :rules="[
            { required: projectForm.hasOpenComprehensiveMinimumGuarantee ? true : false, message: '请输入综合保底', trigger: 'blur' }
          ]">
            <el-input class="select-minimum-guarantee" @input="comprehensiveMinimumGuaranteeAmountInput"
              v-model="projectForm.comprehensiveMinimumGuaranteeAmount" placeholder="请输入">
              <span slot="suffix">
                {{ projectForm.comprehensiveMinimumGuaranteeType === 1?'元/m²/月':'元/月'}}</span>
            </el-input>
            <el-select class="w120" v-model="projectForm.comprehensiveMinimumGuaranteeType"
              @change="changeComprehensiveMinimumGuaranteeType">
              <el-option v-for="item in comprehensiveMinimumGuaranteeList" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否包含">
            <el-checkbox v-model="projectForm.hasExtraFee">增值服务</el-checkbox>
            <el-checkbox v-model="projectForm.hasCityMatching">市内配送</el-checkbox>
            <el-checkbox v-model="projectForm.hasCancelOrder">订单取消</el-checkbox>
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <p class="label2">场租计费规则</p>
        <div class="row-item">
          <el-form-item label="仓库" prop="warehouseId">
            <el-select v-model="projectForm.warehouseId" placeholder="请选择仓库">
              <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地推折算系数" prop="pileConversionFactor">
            <el-input @input="localConversionCoefficientInput" v-model="projectForm.pileConversionFactor"
              placeholder="请输入地推折算系数">
              <span slot="suffix">个/平方米</span>
            </el-input>
          </el-form-item>
          <el-form-item label="实占面积" prop="useArea">
            <el-input @input="useAreaInput" v-model="projectForm.useArea" placeholder="请输入实占面积"></el-input>
          </el-form-item>
          <el-form-item label="货架折算系数" prop="shelfConversionFactor">
            <el-input @input="shelfConversionFactorInput" v-model="projectForm.shelfConversionFactor"
              placeholder="请输入货架折算系数">
              <span slot="suffix">个/平方米</span>
            </el-input>
          </el-form-item>
          <el-form-item label="场租月单价" prop="rentPriceMonth">
            <el-input @input="rentPriceMonthInput" v-model="projectForm.rentPriceMonth" placeholder="请输入场租月单价">
              <span slot="suffix">元/月</span>
            </el-input>
          </el-form-item>
          <el-form-item label="税率" prop="storageTaxRate">
            <el-input @input="rentalCostsTaxRateInput" v-model="projectForm.storageTaxRate"
              placeholder="示例：税率6%，填写0.06"></el-input>
          </el-form-item>
        </div>

        <div class="switch-title">
          <p class="sub-title">场地优惠</p>
          <el-switch class="custom-switch" active-color="#2E68EA" v-model="projectForm.venueDiscounts"
            :active-text="projectForm.venueDiscounts ? '开启优惠' : '关闭优惠'">
          </el-switch>
        </div>
        <div v-show="projectForm.venueDiscounts" class="venue-discounts">
          <div :class="[
              'venue-type-name',
              {
                'venue-active': item.id == projectForm.venueDiscountsType
              }
            ]" v-for="(item, index) in venueDiscountsTypeList" :key="index" @click="selectVenueDiscountsType(item.id)">
            {{ item.name }}
          </div>
        </div>
        <div v-show="projectForm.venueDiscounts">
          <div class="row-item" v-if="projectForm.venueDiscountsType == 1">
            <el-form-item label="约定坪效" prop="area">
              <el-input class="select-flag" @input="areaInput" v-model="projectForm.area" :placeholder="!projectForm.areaStatus ? '无需输入' : '请输入约定坪效'
                  " :disabled="!projectForm.areaStatus">
              </el-input>
              <el-select class="w60" v-model="projectForm.areaStatus" @change="changeAreaStatus">
                <el-option v-for="item in disabledList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="坪数规则" prop="areaUtilizationType" v-show="projectForm.areaStatus">
              <el-select v-model="projectForm.areaUtilizationType" placeholder="请选择坪数规则">
                <el-option v-for="item in areaUtilization" :key="item.id" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="row-item" v-else>
            <el-form-item label="面积减免" prop="reduceArea">
              <el-input @input="areaReductionInput" v-model="projectForm.reduceArea" placeholder="请输入面积减免">
                <span slot="suffix">㎡</span>
              </el-input>
            </el-form-item>
          </div>
        </div>

        <div class="switch-title">
          <p class="sub-title">场地保底</p>
          <el-switch class="custom-switch" active-color="#2E68EA" v-model="projectForm.guaranteedRentPriceStatus"
            :active-text="projectForm.guaranteedRentPriceStatus?'开启保底':'关闭保底'">
          </el-switch>
        </div>
        <div class="row-item" v-show="projectForm.guaranteedRentPriceStatus">
          <el-form-item label="场地保底" prop="guaranteedRentPrice" style="margin-bottom: 8px;" :rules="[
                { required: projectForm.guaranteedRentPriceStatus ? true : false, message: '请输入场地保底', trigger: 'blur' }
              ]">
            <el-input class="select-minimum-guarantee" @input="guaranteedRentPriceInput"
              v-model="projectForm.guaranteedRentPrice" placeholder="请输入">
              <span slot="suffix">元/月</span>
            </el-input>
            <el-select class="w120" v-model="projectForm.guaranteedRentPriceType">
              <el-option v-for="item in guaranteedRentPriceList" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <p class="label2">操作收入计费规则</p>
        <p class="sub-title">税率</p>
        <div class="row-item">
          <el-form-item label="税率" prop="operatorTaxRate">
            <el-input @input="operateTaxRateInput" v-model="projectForm.operatorTaxRate"
              placeholder="示例：税率6%，填写0.06"></el-input>
          </el-form-item>
        </div>
        <div class="switch-title">
          <p class="sub-title">操作保底</p>
          <el-switch class="custom-switch" active-color="#2E68EA" v-model="projectForm.guaranteedOperatePriceStatus"
            :active-text="projectForm.guaranteedOperatePriceStatus?'开启保底':'关闭保底'">
          </el-switch>
        </div>
        <div class="row-item" v-show="projectForm.guaranteedOperatePriceStatus">
          <el-form-item label="操作保底" prop="guaranteedOperatePrice" :rules="[
              { required: projectForm.guaranteedOperatePriceStatus?true:false, message: '请输入操作保底', trigger: 'blur' }
            ]">
            <el-input class="select-minimum-guarantee" @input="guaranteedOperatePriceInput"
              v-model="projectForm.guaranteedOperatePrice" placeholder="请输入">
              <span slot="suffix">{{ guaranteedOperateUnitObj[projectForm.guaranteedOperatePriceType] }}</span>
            </el-input>
            <el-select class="w120" v-model="projectForm.guaranteedOperatePriceType"
              @change="changeGuaranteedOperatePrice">
              <el-option v-for="item in guaranteedOperatePriceList" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <p class="sub-title">订单分拣</p>
        <div class="row-item">
          <el-form-item label="计费依据" prop="chargeFoundation">
            <el-select v-model="projectForm.chargeFoundation" placeholder="请选择计费依据">
              <el-option v-for="item in chargeFoundationList" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="起步价格" prop="startPrice">
            <el-input @input="startPriceInput" v-model="projectForm.startPrice" placeholder="请输入起步价格">
              <span slot="suffix">元/单</span>
            </el-input>
          </el-form-item>
          <el-form-item label="件数范围" prop="number">
            <el-input class="select-flag" @input="numberInput" v-model="projectForm.number" :placeholder="
                !projectForm.numberStatus ? '无需输入' : '请输入件数范围'
              " :disabled="!projectForm.numberStatus"></el-input>
            <el-select class="w60" v-model="projectForm.numberStatus" @change="changeNumberStatus">
              <el-option v-for="item in disabledList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="额外费用" prop="additionalCosts">
            <el-input @input="additionalCostsInput" v-model="projectForm.additionalCosts" placeholder="请输入额外费用"
              :disabled="!projectForm.numberStatus">
              <span slot="suffix">元/件</span>
            </el-input>
          </el-form-item>
        </div>
        <p class="sub-title">订单取消</p>
        <div class="row-item">
          <el-form-item label="订单取消价格" prop="orderCancelUnitPrice">
            <el-input @input="orderCancelUnitPriceInput" v-model="projectForm.orderCancelUnitPrice"
              placeholder="请输入订单取消价格">
              <span slot="suffix">元/单</span>
            </el-input>
          </el-form-item>
        </div>
        <div class="borderTop">
          <p class="sub-title">退货处理</p>
          <div class="row-item">
            <el-form-item label="退货起步价格" prop="returnStartingPrice">
              <el-input @input="returnStartingPriceInput" v-model="projectForm.returnStartingPrice" placeholder="请输入价格">
                <span slot="suffix">元/单</span>
              </el-input>
            </el-form-item>
            <el-form-item label="超件退货价格" prop="returnPriceOfSuperParts">
              <el-input @input="returnPriceOfSuperPartsInput" v-model="projectForm.returnPriceOfSuperParts"
                placeholder="请输入费用"></el-input>
            </el-form-item>
            <el-form-item label="退货件数范围" prop="rangeOfReturnedItems">
              <el-input class="select-flag" @input="rangeOfReturnedItemsInput"
                v-model="projectForm.rangeOfReturnedItems" :placeholder="
                  !projectForm.rangeOfReturnedItemsStatus
                    ? '无需输入'
                    : '请输入范围'
                " :disabled="!projectForm.rangeOfReturnedItemsStatus"></el-input>
              <el-select class="w60" v-model="projectForm.rangeOfReturnedItemsStatus"
                @change="changeRangeOfReturnedItemsStatus">
                <el-option v-for="item in disabledList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="borderTop">
          <p class="sub-title">大宗出库</p>
          <div class="row-item">
            <el-form-item label="大宗出库价格" prop="bulkDeliveryPrice">
              <el-input @input="bulkDeliveryPriceInput" v-model="projectForm.bulkDeliveryPrice"
                placeholder="请输入费用"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="borderTop">
          <p class="sub-title">卸货入库</p>
          <div class="row-item">
            <el-form-item label="卸货价格" prop="unloadingPrice">
              <el-input @input="unloadingPriceInput" v-model="projectForm.unloadingPrice"
                placeholder="请输入费用"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="borderTop">
          <div class="increment-service">
            <p class="sub-title">增值服务</p>
            <div class="row-item" v-for="(domain, index) in projectForm.domains" :key="index">
              <span class="sort">{{index+1}}</span>
              <div class="row-item-content">
                <el-form-item class="service-name" label="服务名称" :prop="'domains.' + index + '.serviceType'" :rules="{
                    required: true, message: '服务名称不能为空', trigger: 'blur'
                  }">
                  <el-select v-model="domain.serviceType" placeholder="请选择服务名称" @change="changeServiceName(index)">
                    <el-option v-for="item in serviceNameList" :key="item.id" :label="item.serviceName"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="单价（元）" :prop="'domains.' + index + '.unitPrice'" :rules="{
                    required: true, message: '单价不能为空', trigger: 'blur'
                  }">
                  <el-input @input="unitPriceInput(index)" v-model="domain.unitPrice" placeholder="请输入金额"></el-input>
                  <span class="remove-domain" @click.prevent="removeDomain(domain)"></span>
                </el-form-item>
              </div>
            </div>
          </div>
          <div>
            <el-button type="text" class="btn-text" @click="addDomain">+添加服务</el-button>
          </div>
        </div>
      </div>
      <div class="row">
        <p class="label2">物流计费规则</p>
        <div class="logistics-row">
          <LogisticsPage :parentProjectsName="projectsName" :parentExpressTabs="expressTabs"
            :parentCityDeliveryUnitPrice="projectForm.cityDeliveryUnitPrice" @addProject="addProject"></LogisticsPage>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getDecimal, getInteger, getThreeDecimal } from "common/js/util";
import Logistics from "models/logistics";
const logistics = new Logistics();
import ProjectManage from "models/project-manage";
const projectManage = new ProjectManage();
import LogisticsPage from '@/components/base/project/logistics.vue';
import customerMixins from "@/common/mixins/customer.js"
import projectManageMixins from "@/common/mixins/project-manage.js"
import warehouseMixins from "@/common/mixins/warehouse.js"
export default {
  mixins: [customerMixins, projectManageMixins, warehouseMixins],
  components: {
    LogisticsPage,
  },
  data() {
    return {
      projectsName: '',
      expressTypeList: [],      /* 使用范围列表 */
      expressTabs: [
        {id: 29, name: '市内配送', expressMethod: 0, tableList: []},
      ],
      logisticsPlusChargesList: [
        {id:1, name: '有'},
        {id:0, name: '无'}
      ],
      venueDiscountsTypeList: [
        {id:1, name: '约定坪效'},
        {id:2, name: '面积减免'}
      ],
      projectForm: {
        id: "",
        warehouseId: "",
        customerId: "",
        projectName: "",
        dataSource: "",
        useArea: "",
        pileConversionFactor: "",
        shelfConversionFactor: "",
        shareArea: "",
        cityDeliveryUnitPrice: "",
        head: "",
        date: "",
        number: "",
        // 税率
        taxRate: "",
        // 计费规则备注
        remark: "",
        projectsDesc: "",
        // 物流税率
        logisticTaxRate: "",
        // 场租税率
        storageTaxRate: "",
        // 操作税率
        operatorTaxRate: "",
        numberStatus: false,
        // 计费依据
        chargeFoundation: 1,
        startPrice: "",
        additionalCosts: "",
        returnStartingPrice: "",
        rangeOfReturnedItems: "",
        rangeOfReturnedItemsStatus: false,
        returnPriceOfSuperParts: "",
        bulkDeliveryPrice: "",
        unloadingPrice: "",
        contractArea: '',
        orderCancelUnitPrice: "",
        area: "",
        areaStatus: false,
        areaUtilizationType: "",
        rentPriceMonth: "",
        finalOrderTime: '',
        domains: [{
          serviceType: null,
          serviceName: '',
          unitPrice: null
        }],
        // 面积减免
        reduceArea: "",
        logisticsInterceptChargeFlag: 1,
        // 是否开启综合保底，默认开启
        hasOpenComprehensiveMinimumGuarantee: true,
        // 综合保底类型；默认保底面积
        comprehensiveMinimumGuaranteeType: 1,
        // 综合保底金额
        comprehensiveMinimumGuaranteeAmount: null,
        // 是否包含增值服务默认包含
        hasExtraFee: true,
        // 是否包含增值服务默认包含
        hasCityMatching: true,
        // 是否包含订单取消默认包含
        hasCancelOrder: true,
        // 场地月保底金额
        guaranteedRentPrice: null,
        // 是否开启场地优惠，默认开启
        venueDiscounts: true,
        // 场地优惠类型，默认约定坪效
        venueDiscountsType: 1,
        // 是否开启场地月保底，默认开启
        guaranteedRentPriceStatus: true,
        // 场地月保底类型；默认场地月保底
        guaranteedRentPriceType: 1,
        // 是否开启操作保底，默认开启
        guaranteedOperatePriceStatus: true,
        // 操作保底金额
        guaranteedOperatePrice: null,
        // 操作保底类型；默认金额保底
        guaranteedOperatePriceType: 'fee'
      },
      projectFormRules: {
        warehouseId: [
          { required: true, message: "请选择仓库", trigger: "change" },
        ],
        customerId: [
          { required: true, message: "请选择客户", trigger: "change" },
        ],
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        dataSource: [
          { required: true, message: "请选择数据来源", trigger: "change" },
        ],
        date: [
          { required: true, message: "请选择合同时间", trigger: "change" },
        ],
        logisticsInterceptChargeFlag: [
          { required: true, message: "请选择物流加收费", trigger: "change" },
        ],
        storageTaxRate: [{ required: true, message: "请输入场租税率", trigger: "blur" }],
        operatorTaxRate: [{ required: true, message: "请输入操作税率", trigger: "blur" }],
        useArea: [
          { required: true, message: "请输入实占面积", trigger: "blur" },
        ],
        pileConversionFactor: [
          { required: true, message: "请输入地堆折算系数", trigger: "blur" },
        ],
        shelfConversionFactor: [
          { required: true, message: "请输入货架折算系数", trigger: "blur" },
        ],
        shareArea: [
          { required: true, message: "请输入分摊面积", trigger: "blur" },
        ],
        head: [{ required: true, message: "请选择负责人", trigger: "change" }],
        chargeFoundation: [
          { required: true, message: "请选择计费依据", trigger: "change" },
        ],
        startPrice: [
          { required: true, message: "请输入起步价", trigger: "blur" },
        ],
        orderCancelUnitPrice: [
          { required: true, message: "请输入订单取消价格", trigger: "blur" },
        ],
        returnStartingPrice: [
          { required: true, message: "请输入退货起步价格", trigger: "blur" },
        ],
        bulkDeliveryPrice: [
          { required: true, message: "请输入大宗出库价格", trigger: "blur" },
        ],
        unloadingPrice: [
          { required: true, message: "请输入卸货价格", trigger: "blur" },
        ],
        logisticTaxRate: [
          { required: true, message: "请输入物流税率", trigger: "blur" },
        ],
        taxRate: [
          { required: true, message: "请输入税率", trigger: "blur" },
        ],
        rentPriceMonth: [
          { required: true, message: "请输入场租月单价", trigger: "blur" },
        ],
      },
    };
  },

  created() {
    this.initHeadList();
    this.initWarehouse();
    this.initCustomerList();
    this.initGetExpressTypeList()
    this.initServiceNameList()
  },

  methods: {
    /* 获取快递列表 */
    initGetExpressTypeList() {
      logistics.getExpressData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.expressTypeList = arr;
        }
      });
    },
    /* 新增项目 */
    addProject(formName, expressCusRuleBaseInfoReqVoList) {
      if (!this.projectForm.areaStatus) {
        this.projectForm.area = "";
      } else {
        if (this.projectForm.area === "") {
          this.$message.error("请输入坪数");
          return false;
        } else if (this.projectForm.areaUtilizationType === "") {
          this.$message.error("请选择坪数规则");
          return false;
        }
      }
      if (!this.projectForm.numberStatus) {
        this.projectForm.number = "";
      } else {
        if (this.projectForm.number === "") {
          this.$message.error("请输入件数范围");
          return false;
        }
        if (this.projectForm.additionalCosts === "") {
          this.$message.error("请输入额外费用");
          return false;
        }
      }
      if (!this.projectForm.rangeOfReturnedItemsStatus) {
        this.projectForm.rangeOfReturnedItems = "";
      } else {
        if (this.projectForm.rangeOfReturnedItems === "") {
          this.$message.error("请输入退货件数范围");
          return false;
        }
        if (this.projectForm.returnPriceOfSuperParts === "") {
          this.$message.error("请输入超件退货价格");
          return false;
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {};
          data.projectsName = this.projectForm.projectName;
          data.warehouseId = this.projectForm.warehouseId;
          data.customerId = this.projectForm.customerId;
          data.businessOwner1 = this.projectForm.head;
          data.contractBeginTime = this.projectForm.date[0];
          data.contractEndTime = this.projectForm.date[1];
          data.dataSource = this.projectForm.dataSource;
          data.logisticsInterceptChargeFlag = this.projectForm.logisticsInterceptChargeFlag;
          data.taxRate = this.projectForm.taxRate;
          data.remark = this.projectForm.remark;
          data.projectsDesc = this.projectForm.projectsDesc;
          data.logisticTaxRate = this.projectForm.logisticTaxRate;
          data.storageTaxRate = this.projectForm.storageTaxRate;
          data.operatorTaxRate = this.projectForm.operatorTaxRate;
          data.useArea = this.projectForm.useArea;
          data.pileConversionFactor = this.projectForm.pileConversionFactor === "" ? 0 : Number(this.projectForm.pileConversionFactor);
          data.shelfConversionFactor = this.projectForm.shelfConversionFactor === "" ? 0 : Number(this.projectForm.shelfConversionFactor);
          data.shareArea = this.projectForm.shareArea;
          data.bulkUnitPrice = this.projectForm.bulkDeliveryPrice === "" ? 0 : Number(this.projectForm.bulkDeliveryPrice);
          data.orderCancelUnitPrice = this.projectForm.orderCancelUnitPrice;
          data.unloadUnitPrice = this.projectForm.unloadingPrice;
          data.returnCharge = {};
          data.returnCharge.unitPrice = this.projectForm.returnStartingPrice;
          data.returnCharge.quantityLimit = this.projectForm.rangeOfReturnedItems === "" ? 0 : Number(this.projectForm.rangeOfReturnedItems);
          data.returnCharge.excessUnitPrice = this.projectForm.returnPriceOfSuperParts === "" ? 0 : Number(this.projectForm.returnPriceOfSuperParts);
          data.operatorCharge = {};
          data.operatorCharge.chargeFoundation = this.projectForm.chargeFoundation;
          data.operatorCharge.unitPrice = this.projectForm.startPrice;
          data.operatorCharge.quantityLimit =
            this.projectForm.number === "" ? 0 : Number(this.projectForm.number);
          data.operatorCharge.excessUnitPrice = this.projectForm.additionalCosts === "" ? 0 : Number(this.projectForm.additionalCosts);
          // 操作保底
          data.operateGuaranteedRule = null
          if (this.projectForm.guaranteedOperatePriceStatus) {
            let guaranteedOperatePrice =
              this.projectForm.guaranteedOperatePrice 
              ? this.projectForm.guaranteedOperatePrice
                : 0;
            data.operateGuaranteedRule = {}
            let ruleType = this.projectForm.guaranteedOperatePriceType
            data.operateGuaranteedRule.ruleType = ruleType
            if (ruleType === 'fee') {
              data.operateGuaranteedRule.baseAmount = guaranteedOperatePrice
            } else {
              data.operateGuaranteedRule.baseOrderQuantity = guaranteedOperatePrice
            }
          }
          data.rentChargeType = 1
          data.rentChargeConfig = {};
          data.rentChargeConfig.areaUtilizationType = this.projectForm.areaUtilizationType === "" ? 0 : this.projectForm.areaUtilizationType;
          data.rentChargeConfig.contractArea = this.projectForm.contractArea == ''?0:this.projectForm.contractArea;
          data.rentChargeConfig.areaUtilization = this.projectForm.area === "" ? 0 : this.projectForm.area;
          data.rentChargeConfig.rentPriceMonth = this.projectForm.rentPriceMonth == '' ? 0 : this.projectForm.rentPriceMonth;
          // 场地优惠
          if (this.projectForm.venueDiscounts) {
            data.rentChargeConfig.rentDiscount = this.projectForm.venueDiscountsType
          } else {
            data.rentChargeConfig.rentDiscount = 0
          }
          data.rentChargeConfig.reduceArea = this.projectForm.reduceArea == '' ? 0 : this.projectForm.reduceArea;
          // 场地保底
          if (this.projectForm.guaranteedRentPriceStatus) {
            data.rentChargeConfig.guaranteedRentPrice =
              this.projectForm.guaranteedRentPrice
              ? this.projectForm.guaranteedRentPrice
                : 0;
          } else {
            data.rentChargeConfig.guaranteedRentPrice = 0
          }
          data.finalOrderTime = this.projectForm.finalOrderTime
          data.extraServiceList = this.projectForm.domains
          data.expressCusRuleBaseInfoReqVoList = expressCusRuleBaseInfoReqVoList

          // 综合保底
          if (this.projectForm.hasOpenComprehensiveMinimumGuarantee) {
            if (this.projectForm.comprehensiveMinimumGuaranteeType === 1) {
              // 保底面积
              data.baseGuaranteedRule = {
                ruleType: "area",
                baseGuaranteedUnitPrice: this.projectForm.comprehensiveMinimumGuaranteeAmount
              }
            } else {
              // 保底金额
              data.baseGuaranteedRule = {
                ruleType: "fee",
                minimumFee: this.projectForm.comprehensiveMinimumGuaranteeAmount
              }
            }
            data.minimumFeeRule = {
              hasExtraFee: this.projectForm.hasExtraFee ? 1:0,
              hasCityMatching: this.projectForm.hasCityMatching? 1:0,
              hasCancelOrder: this.projectForm.hasCancelOrder ? 1:0
            }
          } else {
            data.baseGuaranteedRule = null
            data.minimumFeeRule = {
              hasExtraFee: 0,
              hasCityMatching: 0,
              hasCancelOrder: 0
            }
          }

          projectManage.postAddProject(data).then((res) => {
            if (res.success) {
              this.$message.success("新增成功");
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeAreaStatus() {
      if (!this.projectForm.areaStatus) {
        this.projectForm.area = ''
        this.projectForm.areaUtilizationType = ''
      }
    },
    changeNumberStatus() {
      if (!this.projectForm.numberStatus) {
        this.projectForm.number = ''
        this.projectForm.additionalCosts = ''
      }
    },
    changeRangeOfReturnedItemsStatus() {
      if (!this.projectForm.rangeOfReturnedItemsStatus) {
        this.projectForm.rangeOfReturnedItems = ''
        this.projectForm.returnPriceOfSuperParts = ''
      }
    },
    /** 
     * @desc 清空综合保底金额
    */
    changeComprehensiveMinimumGuaranteeType() {
      this.projectForm.comprehensiveMinimumGuaranteeAmount = null
    },
    /** 
     * @desc 清空操作保底金额
    */
    changeGuaranteedOperatePrice() {
      this.projectForm.guaranteedOperatePrice = null
    },
    /* 限制税率 */
    taxRateInput() {
      let taxRate = this.projectForm.taxRate;
      this.projectForm.taxRate = getDecimal(taxRate);
    },
    /* 限制物流税率 */
    logisticTaxRateInput() {
      let logisticTaxRate = this.projectForm.logisticTaxRate;
      this.projectForm.logisticTaxRate = getDecimal(logisticTaxRate);
    },
    /* 限制场租税率 */
    rentalCostsTaxRateInput() {
      let storageTaxRate = this.projectForm.storageTaxRate;
      this.projectForm.storageTaxRate = getDecimal(storageTaxRate);
    },
    /* 限制操作税率 */
    operateTaxRateInput() {
      let operatorTaxRate = this.projectForm.operatorTaxRate;
      this.projectForm.operatorTaxRate = getDecimal(operatorTaxRate);
    },
    /* 实占面积 */
    useAreaInput() {
      let useArea = this.projectForm.useArea;
      this.projectForm.useArea = getDecimal(useArea);
    },
    /* 地推折算系数 */
    localConversionCoefficientInput() {
      let pileConversionFactor = this.projectForm.pileConversionFactor;
      this.projectForm.pileConversionFactor = getDecimal(pileConversionFactor);
    },
    /* 货架折算系数 */
    shelfConversionFactorInput() {
      let shelfConversionFactor = this.projectForm.shelfConversionFactor;
      this.projectForm.shelfConversionFactor = getDecimal(shelfConversionFactor);
    },
    /* 分摊面积 */
    shareAreaInput() {
      let shareArea = this.projectForm.shareArea;
      this.projectForm.shareArea = getDecimal(shareArea);
    },
    /* 合同面积 */
    contractAreaInput() {
      let contractArea = this.projectForm.contractArea;
      this.projectForm.contractArea = getDecimal(contractArea);
    },
    /* 坪数限制 */
    areaInput() {
      let area = this.projectForm.area;
      this.projectForm.area = getDecimal(area);
    },
    /* 场租月单价限制 */
    rentPriceMonthInput() {
      let rentPriceMonth = this.projectForm.rentPriceMonth;
      this.projectForm.rentPriceMonth = getDecimal(rentPriceMonth);
    },
    /* 面积减免限制 */
    areaReductionInput() {
      let reduceArea = this.projectForm.reduceArea;
      this.projectForm.reduceArea = getDecimal(reduceArea);
    },
    /* 月场地保底限制 */
    guaranteedRentPriceInput() {
      let guaranteedRentPrice = this.projectForm.guaranteedRentPrice;
      this.projectForm.guaranteedRentPrice = getDecimal(guaranteedRentPrice);
    },
    /* 起步价限制 */
    startPriceInput() {
      let startPrice = this.projectForm.startPrice;
      this.projectForm.startPrice = getDecimal(startPrice);
    },
    /* 订单取消价格限制 */
    orderCancelUnitPriceInput() {
      let orderCancelUnitPrice = this.projectForm.orderCancelUnitPrice;
      this.projectForm.orderCancelUnitPrice = getDecimal(orderCancelUnitPrice);
    },
    /* 件数限制 */
    numberInput() {
      if (this.projectForm.number > 20) {
        this.projectForm.number = ''
        return this.$message.error('件数范围不能超过20')
      }
      let number = this.projectForm.number;
      this.projectForm.number = getInteger(number);
    },
    /* 操作月保底 */
    guaranteedOperatePriceInput() {
      let guaranteedOperatePrice = this.projectForm.guaranteedOperatePrice;
      this.projectForm.guaranteedOperatePrice = getDecimal(
        guaranteedOperatePrice
      );
    },
    /* 额外费用限制 */
    additionalCostsInput() {
      let additionalCosts = this.projectForm.additionalCosts;
      this.projectForm.additionalCosts = getDecimal(additionalCosts);
    },
    /* 退货起步价格限制 */
    returnStartingPriceInput() {
      let returnStartingPrice = this.projectForm.returnStartingPrice;
      this.projectForm.returnStartingPrice = getDecimal(returnStartingPrice);
    },
    /* 退货件数范围限制 */
    rangeOfReturnedItemsInput() {
      let rangeOfReturnedItems = this.projectForm.rangeOfReturnedItems;
      this.projectForm.rangeOfReturnedItems = getDecimal(rangeOfReturnedItems);
    },
    /* 超件退货价格限制 */
    returnPriceOfSuperPartsInput() {
      let returnPriceOfSuperParts = this.projectForm.returnPriceOfSuperParts;
      this.projectForm.returnPriceOfSuperParts = getDecimal(
        returnPriceOfSuperParts
      );
    },
    /* 大宗出库价格限制 */
    bulkDeliveryPriceInput() {
      let bulkDeliveryPrice = this.projectForm.bulkDeliveryPrice;
      this.projectForm.bulkDeliveryPrice = getDecimal(bulkDeliveryPrice);
    },
    /* 卸货价格限制 */
    unloadingPriceInput() {
      let unloadingPrice = this.projectForm.unloadingPrice;
      this.projectForm.unloadingPrice = getDecimal(unloadingPrice);
    },
    /* 服务单价 */
    unitPriceInput(index) {
      let unitPrice = this.projectForm.domains[index].unitPrice;
      this.projectForm.domains[index].unitPrice = getThreeDecimal(unitPrice);
    },
    /* 添加服务 */
    addDomain() {
      this.projectForm.domains.push({
        serviceType: null,
        serviceName: '',
        unitPrice: null
      });
    },
    removeDomain(item) {
      let index = this.projectForm.domains.indexOf(item)
      if (index !== -1) {
        this.projectForm.domains.splice(index, 1)
      }
    },
    changeServiceName(index) {
      let domainsObj = this.projectForm.domains[index]
      let obj = this.serviceNameList.find(i => { return i.id == domainsObj.serviceType})
      this.projectForm.domains[index].serviceName = obj.serviceName
    },

    /** 
     * @desc 综合保底金额限制
    */
    comprehensiveMinimumGuaranteeAmountInput() {
      let comprehensiveMinimumGuaranteeAmount = this.projectForm.comprehensiveMinimumGuaranteeAmount;
      this.projectForm.comprehensiveMinimumGuaranteeAmount = getDecimal(
        comprehensiveMinimumGuaranteeAmount
      );
    },

    /** 
     * @desc 选择场地优惠类型
     * @param {*} id 场地优惠类型id
    */
    selectVenueDiscountsType(id) {
      this.projectForm.venueDiscountsType = id
    }
  },
};
</script>

<style lang='scss'>
@import '@/assets/style/layout/project/add-project.scss';
</style>